"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pause = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Pause = function Pause() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 22.5V1.5C7.98923 0.676076 7.32392 0.0107716 6.5 0H3.5C2.67608 0.0107716 2.01077 0.676076 2 1.5V22.5C2.01077 23.3239 2.67608 23.9892 3.5 24H6.5C7.32392 23.9892 7.98923 23.3239 8 22.5ZM17.5 0H20.5C21.3239 0.0107716 21.9892 0.676076 22 1.5V22.5C21.9892 23.3239 21.3239 23.9892 20.5 24H17.5C16.6761 23.9892 16.0108 23.3239 16 22.5V1.5C16.0108 0.676076 16.6761 0.0107716 17.5 0Z"
  });
};

exports.Pause = Pause;